export function getPath(): string {
    const path = window.location.pathname.split('/');
    // Handle /db/local/:db, /db/public/:db, or /db/private/:db patterns
    if (path.length >= 4 && path[1] === 'db') {
        return path[3];
    }
    // Legacy pattern /db/:db
    if (path.length == 3 && path[1]) {
        return path[2];
    }
    return null;
}

/**
 * Get the database type from the current path
 */
export function getDbType(): 'local' | 'public' | 'private' | null {
    const path = window.location.pathname.split('/');
    if (path.length >= 3 && path[1] === 'db') {
        if (path[2] === 'local') return 'local';
        if (path[2] === 'public') return 'public';
        if (path[2] === 'private') return 'private';
    }
    return null;
}

/**
 * Check if the current diagram should sync with the server
 * Only public and private paths should sync; local is browser-only
 */
export function shouldSync(): boolean {
    const dbType = getDbType();
    return dbType === 'public' || dbType === 'private';
}

/**
 * Get the full database path for PouchDB sync
 * Returns: public-{dbname} or private-{dbname}
 * Returns null for local paths (no sync)
 * Uses dash separator instead of slash for express-pouchdb compatibility
 */
export function getRemoteDbPath(): string | null {
    const path = window.location.pathname.split('/');
    if (path.length >= 4 && path[1] === 'db') {
        const type = path[2]; // 'local', 'public', or 'private'
        // Local paths don't sync
        if (type === 'local') return null;
        const dbName = path[3];
        return `${type}-${dbName}`;
    }
    return null;
}

export function getParameter(name: string) {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(name);
}

export function viewOnly(): boolean {
    return getParameter('viewonly') == 'true';
}